export const SAVE_ALL_ADDITIONAL_USERS = 'SAVE_ALL_ADDITIONAL_USERS'
export const SAVE_ADDITIONAL_USER = 'SAVE_ADDITIONAL_USER'
